import React__default from 'react';
import { Box, Skeleton } from '@mui/material';
import clsx from 'clsx';
import dayjs from 'dayjs';
import KGrid, { KGridMode } from '../../Dataview/KGrid/index.js';
import DefaultIcon from '../../DefaultIcon/index.js';
import ElementSummary from '../../ElementSummary/index.js';
import ImportElement from './ImportElement.js';
import StyledImportElements, { classes } from './index.styled.js';

var IMPORT_GRID_TEST_ID = "importGrid";
var ImportElements = function (_a) {
    var _b;
    var _c = _a.testId, testId = _c === void 0 ? "ImportElements" : _c, id = _a.id, className = _a.className, uploadKey = _a.uploadKey, elements = _a.elements, _d = _a.KIcon, KIcon = _d === void 0 ? DefaultIcon : _d;
    var noElement = elements.length === 0;
    var singleElement = elements.length === 1;
    var date = dayjs();
    return (React__default.createElement(StyledImportElements, { id: id, "data-testid": testId, className: clsx("ImportElements", className), sx: {
            display: "flex",
            justifyContent: "right",
            paddingRight: function (theme) { return theme.spacing(2); },
            overflowY: "scroll",
            overflow: "auto",
            height: "100%",
            "::-webkit-scrollbar": {
                display: "none" /* Chrome */
            },
            msOverflowStyle: "none" /* IE and Edge */,
            scrollbarWidth: "none" /* Firefox */
        } },
        noElement && (React__default.createElement(KGrid, { className: "ImportElements-NoElementCard", mode: KGridMode.Dataview, testId: IMPORT_GRID_TEST_ID, sx: { display: "flex", alignItems: "center" } },
            React__default.createElement(Box, null,
                React__default.createElement(ElementSummary, { allowNavigation: false, "aria-disabled": true, iconOverMedia: React__default.createElement(KIcon, { sx: { fontSize: "80px !important", color: function (theme) { return theme.palette.common.white; } }, className: "fa-solid fa-cloud-arrow-up" }), allowSelection: false },
                    React__default.createElement(Box, null,
                        React__default.createElement("p", null, date.format("LL")),
                        React__default.createElement(Skeleton, { variant: "text", animation: false, width: 40 }),
                        React__default.createElement(Skeleton, { variant: "text", animation: false }),
                        React__default.createElement(Skeleton, { variant: "text", animation: false, width: 120 })))))),
        singleElement && (React__default.createElement(KGrid, { mode: KGridMode.Dataview, className: classes.kGridContainerSingle, testId: IMPORT_GRID_TEST_ID, sx: { display: "flex", alignItems: "center" } },
            React__default.createElement(Box, { component: "li" },
                React__default.createElement(ImportElement, { uploadKey: uploadKey, uuid: elements[0].uuid, KIcon: KIcon })))),
        !singleElement && !noElement && (React__default.createElement(Box, { sx: {
                width: "30rem",
                "& .MuiMasonry-root": (_b = {
                        display: "flex",
                        alignContent: "center"
                    },
                    _b["& .".concat(classes.importElement, ":nth-of-type(2)")] = {
                        marginTop: "10rem"
                    },
                    _b)
            }, className: classes.kGridContainer },
            React__default.createElement(KGrid, { mode: KGridMode.Masonry, testId: IMPORT_GRID_TEST_ID }, elements.map(function (element) { return (React__default.createElement(Box, { className: classes.importElement, key: element.uuid, component: "li" },
                React__default.createElement(ImportElement, { uploadKey: uploadKey, uuid: element.uuid }))); }))))));
};

export { ImportElements as default };
//# sourceMappingURL=index.js.map
